"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AutocompleteMultiSelect: function() {
        return AutocompleteMultiSelect;
    },
    default: function() {
        return _default;
    },
    useAutocompleteMultiSelectContext: function() {
        return useAutocompleteMultiSelectContext;
    }
});
var _react = _interop_require_wildcard(require("react"));
var _downshift = require("downshift");
var _reactutils = require("@chakra-ui/react-utils");
var _Box = require("../../layouts/Box/index");
var _AutocompleteMultiSelectInput = _interop_require_default(require("./AutocompleteMultiSelectInput"));
var _AutocompleteMultiSelectList = _interop_require_default(require("./AutocompleteMultiSelectList"));
var _AutocompleteMultiSelectSelectedItems = _interop_require_default(require("./AutocompleteMultiSelectSelectedItems"));
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _createContext = _sliced_to_array((0, _reactutils.createContext)({}), 2), AutocompleteMultiSelectProvider = _createContext[0], useAutocompleteMultiSelectContext = _createContext[1];
var getFilteredItems = function(param) {
    var selectedItems = param.selectedItems, inputValue = param.inputValue, items = param.items, itemToString = param.itemToString;
    var lowerCasedInputValue = inputValue.toLowerCase();
    return items.filter(function(item) {
        var itemString = itemToString ? itemToString(item) : item;
        return !selectedItems.includes(item) && itemString.toLowerCase().includes(lowerCasedInputValue);
    });
};
var AutocompleteMultiSelect = function(param) {
    var children = param.children, items = param.items, _param_size = param.size, size = _param_size === void 0 ? "m" : _param_size, itemToString = param.itemToString, useComboboxProps = param.useComboboxProps, useMultipleSelectionProps = param.useMultipleSelectionProps, _param_isDisabled = param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled;
    var _useState = _sliced_to_array((0, _react.useState)(""), 2), inputValue = _useState[0], setInputValue = _useState[1];
    var _useMultipleSelection = (0, _downshift.useMultipleSelection)(_object_spread({
        onStateChange: function onStateChange(param) {
            var newSelectedItems = param.selectedItems, type = param.type;
            switch(type){
                case _downshift.useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
                case _downshift.useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:
                case _downshift.useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
                case _downshift.useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
                    setSelectedItems(newSelectedItems);
                    break;
                default:
                    break;
            }
        }
    }, useMultipleSelectionProps)), selectedItems = _useMultipleSelection.selectedItems, removeSelectedItem = _useMultipleSelection.removeSelectedItem, getSelectedItemProps = _useMultipleSelection.getSelectedItemProps, getDropdownProps = _useMultipleSelection.getDropdownProps, setSelectedItems = _useMultipleSelection.setSelectedItems;
    var filteredItems = (0, _react.useMemo)(function() {
        return getFilteredItems({
            selectedItems: selectedItems,
            inputValue: inputValue,
            items: items,
            itemToString: itemToString
        });
    }, [
        selectedItems,
        inputValue,
        items,
        itemToString
    ]);
    var _useCombobox = (0, _downshift.useCombobox)(_object_spread(_object_spread_props(_object_spread({
        items: filteredItems,
        selectedItem: null
    }, itemToString && {
        itemToString: itemToString
    }), {
        inputValue: inputValue,
        stateReducer: function(_state, actionAndChanges) {
            var changes = actionAndChanges.changes, type = actionAndChanges.type;
            switch(type){
                case _downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:
                case _downshift.useCombobox.stateChangeTypes.ItemClick:
                    return _object_spread_props(_object_spread({}, changes), {
                        isOpen: true
                    });
                default:
                    return changes;
            }
        },
        onStateChange: function onStateChange(param) {
            var newInputValue = param.inputValue, type = param.type, newSelectedItem = param.selectedItem;
            switch(type){
                case _downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:
                case _downshift.useCombobox.stateChangeTypes.ItemClick:
                case _downshift.useCombobox.stateChangeTypes.InputBlur:
                    if (newSelectedItem) {
                        setSelectedItems(_to_consumable_array(selectedItems).concat([
                            newSelectedItem
                        ]));
                        setInputValue("");
                    }
                    break;
                case _downshift.useCombobox.stateChangeTypes.InputChange:
                    setInputValue(newInputValue);
                    break;
                default:
                    break;
            }
        }
    }), useComboboxProps)), isOpen = _useCombobox.isOpen, selectedItemCombobox = _useCombobox.selectItem, getMenuProps = _useCombobox.getMenuProps, getInputProps = _useCombobox.getInputProps, getToggleButtonProps = _useCombobox.getToggleButtonProps, highlightedIndex = _useCombobox.highlightedIndex, getItemProps = _useCombobox.getItemProps;
    return _react.default.createElement(AutocompleteMultiSelectProvider, {
        value: {
            isOpen: isOpen,
            size: size,
            isDisabled: isDisabled,
            items: filteredItems,
            itemToString: itemToString,
            getMenuProps: getMenuProps,
            getInputProps: getInputProps,
            getItemProps: getItemProps,
            getToggleButtonProps: getToggleButtonProps,
            selectedItem: selectedItemCombobox,
            highlightedIndex: highlightedIndex,
            selectedItems: selectedItems,
            removeSelectedItem: removeSelectedItem,
            getSelectedItemProps: getSelectedItemProps,
            getDropdownProps: getDropdownProps,
            reset: function() {
                return setInputValue("");
            }
        }
    }, _react.default.createElement(_Box.Box, {
        position: "relative"
    }, children));
};
AutocompleteMultiSelect.Input = _AutocompleteMultiSelectInput.default;
AutocompleteMultiSelect.List = _AutocompleteMultiSelectList.default;
AutocompleteMultiSelect.SelectedItems = _AutocompleteMultiSelectSelectedItems.default;
var _default = AutocompleteMultiSelect;
